module.exports = __webpack_public_path__ + "static/media/comment-alt-minus.3670cedd.svg";